import { Box, Button, Grid, Paper } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import Loader from "pages/build-test/loader";
import { Link, useHistory } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import NoDataFound from "shared/molecules/no-data";
import { TypographyHeading } from "shared/molecules/typography-layout";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { useEffect, useState } from "react";
import {
  StudentCourseLookupRequest,
  UpdateSingleStdCourseDetails,
  emptyCourseData,
} from "pages/configue/slices/student-course-slice";
import { CourseLookUpFilter } from "./courseLokup-filter/CourseLookupFilter";
import { table } from "./helper";
import configueService from "pages/configue/service";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import {
  checkFeatureAccess,
  plateformConfigueUser,
} from "utils/role-restriction/helper";
import { getValuesByIds, META_FIELD_MAP, PC_METADATA_KEYS, removeDuplicates } from "pages/configue/constants";
import { isEmpty } from "utils/helpers";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getCourseListData } from "utils/metadata-split/metaDataApiFetch";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export const StudentCourseLookUp = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [stdCourses, setStdCourses] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [searchPayload, setSearchPayload] = useState({});
  const [showLoading, setShowLoading] = useState(true);
  const { data, error, loading } = useAppSelector(
    (state) => state.studentCourseLookup
  );
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const { role: userRoleStr } = profileData;
  const userRole = userRoleStr?.split(",");

  const updateMetaData:any=async(listData,metaKey)=>{
    let metadataList = {...metaData};
    metadataList[metaKey] = listData;
   await dispatch(metadataSuccess(metadataList))
   setShowLoading(false);
  }

  const handleUpdateCourseList = async () => {
   try {
     const call1: any = await getCourseListData(updateMetaData);
     updateMetaData(call1[0], call1[1]);
   } catch (error) {
     console.log(error);
   }
 };

  useEffect(() => {
    if(showLoading===false){
      dispatch(StudentCourseLookupRequest({ ...searchPayload, limit, offset }));
    }
    // dispatch(emptyCourseData());
  }, [offset, searchPayload,showLoading]);

  const handleEdit = async (courseId) => {
    const res: any = await configueService.getSingleCourseLookup({
      lookup_id: courseId?.id,
    });
    if (res?.status === 200 && res?.data?.status === "success") {
      dispatch(UpdateSingleStdCourseDetails(res?.data?.data?.[0]));
      history.push(`/configue/student_course_lookup/edit/${courseId?.id}`);
    }
  };

  const handleCopy = async (courseId) => {
    const res: any = await configueService.getSingleCourseLookup({
      lookup_id: courseId,
    });
    if (res?.status === 200 && res?.data?.status === "success") {
      dispatch(UpdateSingleStdCourseDetails(res?.data?.data?.[0]));
      history.push(`/configue/student_course_lookup/duplicate/${courseId}`);
    }
  };

  const handleDelete = async (courseId) => {
    const res: any = await configueService.deleteCourseLookup({
      lookup_id: courseId,
    });
    if (res?.status === 200 && res?.data?.status === "success") {
      dispatch(snackbarRequest({ message: "deleted successfully" }));
      // history.push(`/configue/student_course_lookup`);
      dispatch(StudentCourseLookupRequest({ ...searchPayload, limit, offset }));
    } else {
      dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
    }
  };

  const takeRequiredValue = (classList, key) => {
    const classNameList = classList?.map((SingleClass) => {
      return SingleClass[`${key}`];
    });
    return classNameList;
  };

  const convertDataToTableData = () => {
    const tableData = data.map((item, i) => {
      let singleCourse = { ...item };

      singleCourse["class_list"] = getValuesByIds(
        item?.class_id_list,
        META_FIELD_MAP.CLASS_ID,
        META_FIELD_MAP.CLASS_NAME,
        PC_METADATA_KEYS.CLASS_LIST,
        metaData
      );
      singleCourse["course_list"] = getValuesByIds(
        item?.course_id,
        META_FIELD_MAP.COURSE_ID,
        META_FIELD_MAP.COURSE_NAME,
        PC_METADATA_KEYS.COURSE_LIST,
        metaData
      );
      singleCourse["year_list"] = getValuesByIds(
        item?.year_id_list,
        META_FIELD_MAP.ACADEMIC_YEAR_ID,
        META_FIELD_MAP.ACADEMIC_YEAR_NAME,
        PC_METADATA_KEYS.ACADEMIC_YEAR_LIST,
        metaData
      );
      singleCourse["state_list"] = getValuesByIds(
        item?.state_id_list,
        META_FIELD_MAP.STATE_ID,
        META_FIELD_MAP.STATE_NAME,
        PC_METADATA_KEYS.STATE_LIST,
        metaData
      );
      singleCourse["batch_list"] = getValuesByIds(
        item?.batch_id_list,
        META_FIELD_MAP.BATCH_ID,
        META_FIELD_MAP.BATCH_NAME,
        PC_METADATA_KEYS.BATCH_LIST,
        metaData
      );
      singleCourse["board_list"] = getValuesByIds(
        item?.board_id_list,
        META_FIELD_MAP.BOARD_ID,
        META_FIELD_MAP.BOARD_NAME,
        PC_METADATA_KEYS.BOARD_LIST,
        metaData
      );
      singleCourse["college_list"] = removeDuplicates(getValuesByIds(
        item?.college_id_list,
        META_FIELD_MAP.COLLEGE_ID,
        META_FIELD_MAP.COLLEGE_NAME,
        PC_METADATA_KEYS.COLLEGE_LIST,
        metaData
      ));
      singleCourse["registration_status_list"] = getValuesByIds(
        item?.registration_status_id_list,
        META_FIELD_MAP.REGISTRATION_STATUS_ID,
        META_FIELD_MAP.REGISTRATION_STATUS_NAME,
        PC_METADATA_KEYS.REGISTRATION_STATUS_LIST,
        metaData
      );
      return singleCourse;
    });
    setStdCourses(tableData);
  };

  useEffect(() => {
    if (data.length > 0) {
      convertDataToTableData();
    } else {
      setStdCourses([]);
    }
  }, [data]);

  useEffect(()=>{
    handleUpdateCourseList();
  },[]);

  const hasModificationAccess = checkFeatureAccess(
    userRole,
    plateformConfigueUser?.STD_COURSE_LU_READ_WRITE
  );

  if(showLoading){
    return <p>Fetching CourseList data Please Wait ....</p>
  }

  return (
    <div>
      <ContentRight>
        {hasModificationAccess && (
          <Link
            to="/configue/student_course_lookup/create"
            className={classes.label}
          >
            <Button variant="contained">Create New Course Map</Button>
          </Link>
        )}
      </ContentRight>
      <TypographyHeading>Course Lookup</TypographyHeading>
      <Paper sx={{ mt: 2, p: 2 }}>
        <Box sx={{ mt: 2, mb: 2 }}>
          <CourseLookUpFilter
            setSearchPayload={setSearchPayload}
            setOffset={setOffset}
          />
        </Box>
        {loading && <Loader />}
        {!loading && stdCourses.length > 0 && !error ? (
          <div>
            <CollapsibleTable
              data={stdCourses}
              table={table}
              id="id"
              handleEdit={hasModificationAccess ? handleEdit : ""}
              handleCopy={hasModificationAccess ? handleCopy : ""}
              handleDelete={hasModificationAccess ? handleDelete : ""}
              rowsPerPageCount={20}
              paginationSegmentApi="false"
              hasPageApiCall={false}
              showPaginationFooter={false}
            />
          </div>
        ) : (
          <div>
            {!loading && (
              <NoDataFound message="Please Search for Student Course List" />
            )}
          </div>
        )}
        <Box className={classes.BtnWrapper}>
          <Button
            onClick={() => {
              setOffset(offset - 10);
            }}
            className={classes.Btn}
            disabled={offset == 0}
            variant="contained"
            size="medium"
          >
            prev
          </Button>
          <Button
            onClick={() => {
              setOffset(offset + 10);
            }}
            className={classes.Btn}
            disabled={data.length <= 9}
            variant="contained"
            size="medium"
          >
            next
          </Button>
        </Box>
      </Paper>
    </div>
  );
};
